import { formatDate } from "@/lib/api";

export const Corrections = ({ items }) => (
  <aside className="mt-12 pt-5 border-t border-[var(--rule)]" data-testid="article-corrections">
    <p className="meta !text-[var(--ink)]">{items.length === 1 ? "Correction" : "Corrections"}</p>
    <ul className="mt-3 grid gap-3">
      {items.map((c, i) => (
        <li key={i} className="font-ui text-sm text-[var(--ink-2)] leading-relaxed" data-testid={`article-correction-${i}`}>
          <span className="font-semibold text-[var(--ink)]">{formatDate(c.date)}:</span> {c.text}
        </li>
      ))}
    </ul>
  </aside>
);
